import { DialogModule } from '@progress/kendo-angular-dialog';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LobbyGridComponent } from './lobby-grid/lobby-grid.component'
import { StaffGridComponent } from './staff-grid/staff-grid.component';
import { LobbyStaffStatusComponent } from './lobby-staff-status.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { FormsModule,ReactiveFormsModule  } from '@angular/forms';
import { CdTimerModule } from 'angular-cd-timer';
import { SharedModule } from 'src/app/shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { lobbyStaffStatusReducer } from './state';
import { LobbyStaffStatusEffects } from './state/effects/lobby-staff-status.effects';
import { ImpersonateAssistComponent } from 'src/app/lobby/lobby-staff-status/shared/impersonate-assist/impersonate-assist.component';
import { AppTimerModule } from '../../shared/layout/app-layout/app-timer/app-timer.module';

@NgModule({
  declarations: [LobbyGridComponent, StaffGridComponent, LobbyStaffStatusComponent,ImpersonateAssistComponent],
  imports: [
    CommonModule, 
    GridModule,
    FormsModule,
    CdTimerModule,
    DialogModule,
    SharedModule,
    ReactiveFormsModule,
    StoreModule.forFeature('lobbyStaffStatus', lobbyStaffStatusReducer),
    EffectsModule.forFeature([LobbyStaffStatusEffects]),
    AppTimerModule,
  ],
  exports: [LobbyStaffStatusComponent,],
})
export class LobbyStaffStatusModule { }
